import { DeleteModal } from '@presentation/components/templates'
import { DeleteModalProps } from '@presentation/types/components/templates'

type Props = {
  id: number
  onDelete: () => void
}

const DeleteGrupoAcessoModal: React.FC<Props> = ({ id, onDelete }) => {
  const modalConfigs: DeleteModalProps = {
    id,
    path: '/grupos-acesso',
    nameForTitle: 'Grupo de Acesso',
    onDelete
  }

  return <DeleteModal {...modalConfigs} />
}

export default DeleteGrupoAcessoModal
